import { render, staticRenderFns } from "./ProcessWizardTemplate.vue?vue&type=template&id=003b9cdc&scoped=true"
import script from "./ProcessWizardTemplate.vue?vue&type=script&lang=ts"
export * from "./ProcessWizardTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ProcessWizardTemplate.vue?vue&type=style&index=0&id=003b9cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b9cdc",
  null
  
)

export default component.exports